import Language from './Language';

const TAG_DATA: any = {
  biz: {
    job: {
      ja: '就職、転職',
      en: 'Job',
    },
    finance_and_insurance: {
      ja: '金融、保険',
      en: 'Finance and Insurance',
    },
    real_estate: {
      ja: '不動産',
      en: 'Real Estate',
    },
    b2b_solution_and_service: {
      ja: 'B2B ソリューション・サービス',
      en: 'B2B Solution and Service',
    },
    arts_and_entertainment: {
      ja: 'アート、エンターテインメント',
      en: 'Arts and Entertainment',
    },
    education_and_learning: {
      ja: '教育・学習',
      en: 'Education and Learning',
    },
    travel: {
      ja: '旅行',
      en: 'Travel',
    },
    shopping_mall_and_marketplace: {
      ja: 'ショッピングモール、マーケットプレイス',
      en: 'Shopping Mall and Marketplace',
    },
    beauty_and_fitness: {
      ja: '美容、フィットネス',
      en: 'Beauty and Fitness',
    },
    food_and_drink: {
      ja: '食品・飲食',
      en: 'Food and Drink',
    },
    automotive: {
      ja: '自動車、バイク',
      en: 'Automotive',
    },
    internet_and_telecom: {
      ja: 'インターネット・通信インフラ',
      en: 'Internet and Telecom',
    },
    healthcare: {
      ja: '医療・健康',
      en: 'Healthcare',
    },
    books_and_literature: {
      ja: '書籍、文学',
      en: 'Books and Literature',
    },
    news_and_media: {
      ja: 'ニュース、メディア',
      en: 'News and Media',
    },
    community_and_matching: {
      ja: 'コミュニティ・出会い',
      en: 'Community and Matching',
    },
    web_portal: {
      ja: 'インターネット総合',
      en: 'Web Portal',
    },
    fashion: {
      ja: 'ファッション',
      en: 'Fashion',
    },
    retail: {
      ja: '小売',
      en: 'Retail',
    },
    home_and_garden: {
      ja: '住居、ガーデニング',
      en: 'Home and Garden',
    },
    life_events: {
      ja: '冠婚葬祭',
      en: 'Life Events',
    },
    computers_and_electronics: {
      ja: 'コンピュータ、電化製品',
      en: 'Computers and Electronics',
    },
    hobbies_and_leisure: {
      ja: '趣味、レジャー',
      en: 'Hobbies and Leisure',
    },
    sports: {
      ja: 'スポーツ',
      en: 'Sports',
    },
    games: {
      ja: 'ゲーム',
      en: 'Games',
    },
    people_and_society: {
      ja: '人々、社会',
      en: 'People and Society',
    },
    law_and_government: {
      ja: '法律、行政',
      en: 'Law and Government',
    },
    others: {
      ja: 'その他',
      en: 'Others',
    },
  },
};

const AVAILABLE_TAGS = Object.keys(TAG_DATA)
  .map(prefix => Object.keys(TAG_DATA[prefix]).map(l => `${prefix}:${l}`))
  .reduce((acc, val) => acc.concat(val), []);

class Tag {
  public readonly label: string;
  public readonly name: string;

  constructor({ label, name }: { label: string; name: string }) {
    this.label = label;
    this.name = name;
  }

  public static fromJSON = (v: any) => {
    const { label, name } = Object.assign({}, v);

    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (!AVAILABLE_TAGS.includes(label)) throw new TypeError('.label must be a valid Tag Label string');

    return new Tag({
      label,
      name,
    });
  };
}

export default Tag;

export const getAllTags = (language: Language): Tag[] => {
  const lang = language.toLowerCase();
  return AVAILABLE_TAGS.map(label => {
    const [k1, k2] = label.split(':');
    return new Tag({ label, name: TAG_DATA[k1][k2][lang] });
  });
};
